<template>
  <div>
    <v-container class="pt-0">
      <v-row>
        <v-col>
          <span class="headline pb-1">{{$t('playerProfileDialog.title')}}</span>
        </v-col>
      </v-row>
      <v-row v-if="user">
        <v-col>
          <player-profile-content :user="user" />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import PlayerProfileContent from "@/widgets/PlayerProfileContent";

export default {
  name: "UserDetails",
  components: {
    PlayerProfileContent
  },
  props: {
    uid: {
      type: String,
      required: true
    }
  },
  data: function() {
    return {
      user: undefined
    };
  },
  created() {
    this.user = { uid: this.uid };
  },
  mounted() {
    this.refresh();
  },
  methods: {
    refresh() {
      // this.$api
    }
  }
};
</script>
